import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnChanges {
  @Input() totalPages: number;
  @Input() current: number;
  @Output() pageChanged = new EventEmitter<number>();

  first: boolean;
  last: boolean;
  pageOptions: number[];

  ngOnChanges(): void {
    this.updateOptions();
  }

  paginate(page: number): void {
    this.current = page;
    this.pageChanged.emit(page);
    this.updateOptions();
  }

  updateOptions(): void {
    this.pageOptions = [];
    this.first = this.current === 1;
    this.last = this.current === this.totalPages;
    this.pageOptions.push(this.current);

    if (!this.first) {
      this.pageOptions.unshift(this.current - 1);
    }
    if (!this.last) {
      this.pageOptions.push(this.current + 1);
    }
    if (this.pageOptions.length < 3 && this.current + 2 <= this.totalPages) {
      this.pageOptions.push(this.current + 2);
    }
    if (this.pageOptions.length < 3 && this.current - 2 >= 1) {
      this.pageOptions.unshift(this.current - 2);
    }
  }
}
